import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useState } from "react";
import { rem } from "./auth-service-tools172.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { ScrollAreaCorner } from "./auth-service-tools252.js";
import { ScrollAreaRoot } from "./auth-service-tools253.js";
import { ScrollAreaScrollbar } from "./auth-service-tools254.js";
import { ScrollAreaThumb } from "./auth-service-tools255.js";
import { ScrollAreaViewport } from "./auth-service-tools256.js";
import classes from "./auth-service-tools257.js";
const defaultProps = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    scrollbarSize
  } = _ref;
  return {
    root: {
      "--scrollarea-scrollbar-size": rem(scrollbarSize)
    }
  };
});
const ScrollArea = factory((_props, ref) => {
  const props = useProps("ScrollArea", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    scrollbarSize,
    vars,
    type,
    scrollHideDelay,
    viewportProps,
    viewportRef,
    onScrollPositionChange,
    children,
    offsetScrollbars,
    scrollbars,
    onBottomReached,
    onTopReached,
    ...others
  } = props;
  const [scrollbarHovered, setScrollbarHovered] = useState(false);
  const getStyles = useStyles({
    name: "ScrollArea",
    props,
    classes,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(ScrollAreaRoot, {
    type: type === "never" ? "always" : type,
    scrollHideDelay,
    ref,
    scrollbars,
    ...getStyles("root"),
    ...others,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaViewport, { ...viewportProps,
      ...getStyles("viewport", {
        style: viewportProps == null ? void 0 : viewportProps.style
      }),
      ref: viewportRef,
      "data-offset-scrollbars": offsetScrollbars === true ? "xy" : offsetScrollbars || void 0,
      "data-scrollbars": scrollbars || void 0,
      onScroll: e => {
        var _a;

        (_a = viewportProps == null ? void 0 : viewportProps.onScroll) == null ? void 0 : _a.call(viewportProps, e);
        onScrollPositionChange == null ? void 0 : onScrollPositionChange({
          x: e.currentTarget.scrollLeft,
          y: e.currentTarget.scrollTop
        });
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = e.currentTarget;

        if (scrollTop - (scrollHeight - clientHeight) >= 0) {
          onBottomReached == null ? void 0 : onBottomReached();
        }

        if (scrollTop === 0) {
          onTopReached == null ? void 0 : onTopReached();
        }
      },
      children
    }), (scrollbars === "xy" || scrollbars === "x") && /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbar, { ...getStyles("scrollbar"),
      orientation: "horizontal",
      "data-hidden": type === "never" || void 0,
      forceMount: true,
      onMouseEnter: () => setScrollbarHovered(true),
      onMouseLeave: () => setScrollbarHovered(false),
      children: /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaThumb, { ...getStyles("thumb")
      })
    }), (scrollbars === "xy" || scrollbars === "y") && /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbar, { ...getStyles("scrollbar"),
      orientation: "vertical",
      "data-hidden": type === "never" || void 0,
      forceMount: true,
      onMouseEnter: () => setScrollbarHovered(true),
      onMouseLeave: () => setScrollbarHovered(false),
      children: /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaThumb, { ...getStyles("thumb")
      })
    }), /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaCorner, { ...getStyles("corner"),
      "data-hovered": scrollbarHovered || void 0,
      "data-hidden": type === "never" || void 0
    })]
  });
});
ScrollArea.displayName = "@mantine/core/ScrollArea";
const ScrollAreaAutosize = factory((props, ref) => {
  const {
    children,
    classNames,
    styles,
    scrollbarSize,
    scrollHideDelay,
    type,
    dir,
    offsetScrollbars,
    viewportRef,
    onScrollPositionChange,
    unstyled,
    variant,
    viewportProps,
    scrollbars,
    style,
    vars,
    onBottomReached,
    onTopReached,
    ...others
  } = useProps("ScrollAreaAutosize", defaultProps, props);
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, { ...others,
    ref,
    style: [{
      display: "flex",
      overflow: "auto"
    }, style],
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      style: {
        display: "flex",
        flexDirection: "column",
        flex: 1
      },
      children: /* @__PURE__ */jsxRuntimeExports.jsx(ScrollArea, {
        classNames,
        styles,
        scrollHideDelay,
        scrollbarSize,
        type,
        dir,
        offsetScrollbars,
        viewportRef,
        onScrollPositionChange,
        unstyled,
        variant,
        viewportProps,
        vars,
        scrollbars,
        onBottomReached,
        onTopReached,
        children
      })
    })
  });
});
ScrollArea.classes = classes;
ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
ScrollAreaAutosize.classes = classes;
ScrollArea.Autosize = ScrollAreaAutosize;
export { ScrollArea, ScrollAreaAutosize };